var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1800.3 0c-992.53 0-1800 807.47-1800 1800s807.47 1800 1800 1800 1800-807.47 1800-1800-807.47-1800-1800-1800zm-18.73 2806.5c-128.25 0-216.62-96.918-216.62-222.36 0-131.12 91.238-222.3 216.62-222.3 128.3 0 213.75 91.18 216.62 222.3 0 125.43-85.441 222.36-216.62 222.36zm310.72-1063.2c-111.21 131.18-156.77 248.01-151.14 384.8l2.8672 59.852h-307.86l-5.6797-74.137c-14.23-148.22 37.07-304.99 171.05-467.49 108.34-128.3 179.55-228.04 179.55-339.19 0-119.7-74.082-199.52-233.72-202.39-99.73 0-213.8 31.387-285.02 85.555l-85.555-250.82c102.6-65.586 267.98-116.89 447.52-116.89 353.42 0 515.93 205.2 515.93 433.29 0.003906 205.2-125.38 347.68-247.95 487.41z",
    fill: "#7d7562"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.857ee7c129ab0fba6c2c5a094301b05f.svg";
export { ForwardRef as ReactComponent };